import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Grid, TextField, Typography, Table, TableHead, TableBody, TableRow, TableCell } from "@mui/material";

const GasCylinderForm = React.memo(({ formState, onChangeHandler, inputSelected }) => {
  const { t } = useTranslation("common");
  const cylinders = Object.values(formState);

  return cylinders.map((cylinder, index) => (
    <Box key={`cylinder_${index}`} sx={{ mb: 3, p: 2 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
        {`CYL ${index + 1}`}
      </Typography>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            label={t("Gas cylinder numbers")}
            size="small"
            fullWidth
            value={cylinder.cylNumber}
            onChange={(e) => onChangeHandler("cylNumber", e.target.value, index)}
            onClick={(e) => inputSelected(e, `cylNumber|${index}`)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            label={t("Expiring date")}
            size="small"
            fullWidth
            placeholder="DD.MM.YYYY"
            value={cylinder.expirationDate}
            onChange={(e) => onChangeHandler("expirationDate", e.target.value, index)}
            onClick={(e) => inputSelected(e, `expirationDate|${index}`)}
          />
        </Grid>
      </Grid>
      {cylinder.components && cylinder.components.length > 0 && (
        <Table size="small">
          <TableHead>
            <TableRow>
              {cylinder.components.map((component, colIndex) => (
                <TableCell key={`${component.name}${colIndex}`} align="center">
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>{component.name}</Typography>
                  <Typography variant="caption">{component.unit}</Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              {cylinder.components.map((component, colIndex) => (
                <TableCell key={`val_${component.name}${colIndex}`} align="center">
                  <TextField
                    size="small"
                    value={component.spanTarget}
                    onChange={(e) => onChangeHandler("spanTarget", e.target.value, index, component.name)}
                    onClick={(e) => inputSelected(e, `spanTarget|${index}|${component.name}`)}
                    sx={{ width: 100 }}
                  />
                </TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      )}
    </Box>
  ));
});

export default GasCylinderForm;
